import { render, staticRenderFns } from "./ArchivedClasses.vue?vue&type=template&id=0c2091cd&scoped=true"
import script from "./ArchivedClasses.vue?vue&type=script&lang=js"
export * from "./ArchivedClasses.vue?vue&type=script&lang=js"
import style0 from "./ArchivedClasses.vue?vue&type=style&index=0&id=0c2091cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2091cd",
  null
  
)

export default component.exports